export const IMAGE_MIME_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
export const AUDIO_MIME_TYPES = ['audio/wav', 'audio/mp3', 'audio/mp4', 'audio/mpeg'];
export const VIDEO_MIME_TYPES = ['video/quicktime', 'video/mp4', 'video/x-ms-wmv', 'video/x-msvideo'];
